import React from 'react';
import { Helmet } from 'react-helmet';



function TermsOfUse() {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <Helmet>
  <title>Meshum | Compare Car Prices with Sold Listings</title>
  <meta name="description" content="See what similar cars have sold for nearby. Use Meshum to get price insights before buying your next car." />
</Helmet>
      <h1>Terms of Use</h1>
      <p>Last updated: May 2025</p>

      <p>
        Welcome to Meshum. By accessing or using our website, you agree to the following terms and conditions.
      </p>

      <h2>1. Use of the Site</h2>
      <p>
        You may use this site for personal, non-commercial purposes only. You agree not to misuse the platform or interfere with its normal operation.
      </p>

      <h2>2. Account and Data</h2>
      <p>
        If you create an account in the future, you are responsible for maintaining its security. You must not share your login credentials.
      </p>

      <h2>3. Car Listings</h2>
      <p>
        Meshum does not sell vehicles. All listings are for informational purposes only. We do not guarantee pricing accuracy or vehicle availability.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content, including logos, text, graphics, and code, is the property of Meshum or its licensors. You may not copy or redistribute any part of the site without permission.
      </p>

      <h2>5. Disclaimer of Warranties</h2>
      <p>
        The site is provided “as is” without warranties of any kind. Meshum disclaims all liability for errors, omissions, or inaccuracies in the content.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        Meshum is not liable for any damages resulting from your use of the website, including lost profits or data.
      </p>

      <h2>7. Changes to These Terms</h2>
      <p>
        We may update these terms from time to time. Continued use of the site means you accept the new terms.
      </p>

      <h2>8. Contact</h2>
      <p>
        For questions about these terms, contact us at: legal@meshum.com
      </p>
    </div>
  );
}

export default TermsOfUse;
